import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer, combineReducers } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoginLogoutActionTypes } from '../../../../core/auth/user-auth/store/actions/login-logout.action';
import { reducer as searchReducer } from '../../../../core/features/store/reducers/search.reducer';
import { Article, ProductBrand, ProductDocument } from '../../../../core/model';
import { CurrenciesActionTypes } from '../../../../core/site-context/store/actions/currencies.action';
import { LanguagesActionTypes } from '../../../../core/site-context/store/actions/languages.action';
import { PyStateUtils } from '../../../../core/state';
import { SoldToActions } from '../../../sold-to-base/store/actions';
import { CONFORMANCE_EC_BRANDS, CONFORMANCE_EC_SEARCH, DocumentsState, PRODUCT_DOCUMENTS } from '../documents-state';
import * as searchConformanceEcSearchEntitiesReducer from './search-conformance-ec-search-entities.reducer';
import * as searchConformanceEcSearchParamsReducer from './search-conformance-ec-search-params.reducer';
import * as searchConformanceEcReducer from './search-conformance-ec.reducer';

export function getReducers(): ActionReducerMap<DocumentsState, any> {
  return {
    productDocuments: clearStateOnContextChange(
      StateUtils.entityReducer<StateUtils.LoaderState<ProductDocument>>(
        PRODUCT_DOCUMENTS,
        PyStateUtils.loaderReducer<Article>(PRODUCT_DOCUMENTS)
      )
    ),
    conformanceEc: clearStateOnContextChange(
      combineReducers({
        search: searchReducer(CONFORMANCE_EC_SEARCH, searchConformanceEcReducer.reducer),
        searchParams: searchConformanceEcSearchParamsReducer.reducer,
        entities: searchConformanceEcSearchEntitiesReducer.reducer,
        brands: PyStateUtils.loaderReducer<ProductBrand[]>(CONFORMANCE_EC_BRANDS),
      })
    ),
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<DocumentsState>>('DocumentsReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearStateOnContextChange(reducer: ActionReducer<any>, extraActionTypes: string[] = []): ActionReducer<any> {
  return function (state, action) {
    if (
      action.type === LoginLogoutActionTypes.Login ||
      action.type === LoginLogoutActionTypes.Logout ||
      action.type === SoldToActions.ChangeSoldToActionTypes.ChangeSoldToSuccess ||
      action.type === LanguagesActionTypes.LanguageChange ||
      action.type === CurrenciesActionTypes.CurrencyChange ||
      extraActionTypes?.includes(action.type)
    ) {
      state = undefined;
    }
    // clear state on login or is changesoldtosuccess sent on login after soldto is received?
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateOnContextChange];
